import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { SelectionAction } from 'gung-list';
import {
  ActivityInternalService,
  ActivityInternalViewModalComponent,
  AuthService,
  BackendInterceptor,
  CustomerContactService,
  GungModalService,
  MetadataService,
  SelectedCustomerService
} from 'gung-standard';
import { DateUtilService } from 'gung-common';
import { Observable, of } from 'rxjs';
import { first } from 'rxjs';

@Component({
    selector: 'colmec-activity-internal-view-modal',
    templateUrl: './colmec-activity-internal-view-modal.component.html',
    styleUrls: ['./colmec-activity-internal-view-modal.component.scss'],
    standalone: false
})
export class ColmecActivityInternalViewModalComponent extends ActivityInternalViewModalComponent implements OnInit {
  isAdminOrSales: boolean;

  ngOnInit() {
    super.ngOnInit();
    this.authService
      .getCurrentUser()
      .pipe(first())
      .subscribe(user => {
        this.isAdminOrSales = user.roles.indexOf('ADMIN') > -1 || user.roles.indexOf('SALES') > -1;
      });
  }
  getSelectionActions(): Observable<SelectionAction<string>[]> {
    const actions: SelectionAction<string>[] = this.metadataService
      .getMetadataTableList('ACTIVITYINTERNALSTATUS')
      .map(item => ({
        label: 'MARK_AS_' + item.name.toLocaleUpperCase(),
        performAction: (selection: any) => {
          this.data.status = item.id;
          this.activityInternalService.postActivityInternal(this.data).subscribe();
          return of();
        }
      }));
    return of(actions);
  }
}
